import { debounce } from "./utils";

export default function () {
    const footerToggles = document.querySelectorAll(".js-footerMenuToggle");

    footerToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
            setFixedFooterSpacing();
        });
    });

    setFixedFooterSpacing();
    setFooterSpacingObserver();
    const debouncedFooterSpacing = debounce(setFixedFooterSpacing, 250);
    window.addEventListener("resize", debouncedFooterSpacing);
}

function setFixedFooterSpacing() {
    const footer = document.querySelector("footer");
    const main = document.querySelector("main");

    main.style.marginBottom = `${footer.offsetHeight}px`;
}

function setFooterSpacingObserver() {
    var lastWidget = document.querySelector("main > .umb-block-list > section:last-child");
    if (!lastWidget) return;
    var threshold = parseFloat(lastWidget.dataset.obsThreshold);
    if (Number.isNaN(threshold)) {
        threshold = 0.25;
    }
    var obs = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                setFixedFooterSpacing();
            }
        });
    }, {
        threshold
    });
    obs.observe(lastWidget);
}
